<template>
  <path
    d="M8 6.82019V17.1802C8 17.9702 8.87 18.4502 9.54 18.0202L17.68 12.8402C18.3 12.4502 18.3 11.5502 17.68 11.1502L9.54 5.98019C8.87 5.55019 8 6.03019 8 6.82019Z"
  />
</template>
